import { isAfter } from "date-fns";
export const DAY_OF_THE_WEEK_DIC = {
    月曜: 0,
    火曜: 1,
    水曜: 2,
    木曜: 3,
    金曜: 4,
    土曜: 5,
    日曜: 6,
};
export default function compareByDayOfTheWeekAndStartTime(a, b) {
    // 曜日が同じだったら開始時刻で比較
    if (DAY_OF_THE_WEEK_DIC[a.date.value] === DAY_OF_THE_WEEK_DIC[b.date.value]) {
        return isAfter(new Date(`1/1 ${a.start_time.value}`), new Date(`1/1 ${b.start_time.value}`));
    }
    return DAY_OF_THE_WEEK_DIC[a.date.value] > DAY_OF_THE_WEEK_DIC[b.date.value];
}
